import React, {
  useEffect,
  useState
} from 'react';

import {
  fetchRentedProperties
} from '../../services/userService';

function RentedPropertiesPanel() {

  const [properties, setProperties] =
    useState([]);

  useEffect(() => {

    loadProperties();

  }, []);

  const loadProperties = async () => {

    try {

      const data =
        await fetchRentedProperties();

      setProperties(data);

    } catch (error) {

    }
  };

  return (
    <div>

      <h2>
        املاک اجاره شده
      </h2>

      {properties.map((property) => (

        <div
          key={property.id}
          className="property-card"
        >

          <h3>
            {property.title}
          </h3>

          <p>
            {property.address}
          </p>

        </div>

      ))}

    </div>
  );
}

export default RentedPropertiesPanel;